import Axios from "axios";
import { getPathName, getApiHash, getApiToken } from "./helper";

const obtenerDescripciones = async (rubro: string, origen: string, tipoCotizador: string) => {
  const params = {
    hash: await getApiHash(),
    rubro: rubro,
    origen: origen,
    tipoCotizador: tipoCotizador
  };
  const headers = {
    "content-type": "application/json",
    Authorization: "Bearer " + await getApiToken(),
  };

  return await Axios.post(
    await getPathName() +
      "/getdescripcionesjson?random=" +
      (Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000),
    params,
    {
      headers: headers,
    }
  )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      // Manejar el error aquí
      console.error("Error en la solicitud", error);
    });
};

export default obtenerDescripciones;
